<template>
  <mask-layer class="edit-layer" v-show="show" @input="cancelHandle">
    <div class="content">
      <h3>{{title}}</h3>
      <el-form label-width="100px">
        <el-form-item label="原始值">
          <span>{{original}}</span>
        </el-form-item>
        <el-form-item label="更改为">
          <el-input v-model="target" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updateHandle">保存修改</el-button>
          <el-button @click="cancelHandle">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </mask-layer>
</template>
<script>
import MaskLayer from '@/components/MaskLayer'
import { Form, FormItem, Input, Button } from 'element-ui'
export default {
  name: 'EditLayer',
  components: {
    MaskLayer,
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElButton: Button
  },
  data () {
    return {
      show: false,
      title: '编辑数据',
      original: '', // 原始数据
      target: '', // 修改后的数据
      type: 'string',
      time: null, // 定时器
      action: ''
    }
  },
  methods: {
    showLayer (options) {
      options = options || {}
      this.action = ''
      this.title = options.title || '编辑数据'
      this.original = options.data
      this.target = options.data
      this.type = options.type || 'string'
      this.show = true

      return new Promise((resolve, reject) => {
        this.time = setInterval(_ => {
          if (this.action === 'success') {
            if (this.type === 'string') {
              resolve(this.target.trim())
              this.show = false
              clearInterval(this.time)
            }
            if (this.type === 'number') {
              let num = parseFloat(this.target.trim())
              if (!this.checkData(num)) {
                resolve(parseFloat(this.target.trim()))
                this.show = false
                clearInterval(this.time)
              } else {
                this.$message.error('含有非法字符!')
                this.action = ''
              }
            }
          }
          if (this.action === 'cancel') {
            reject(new Error('handle cancel'))
            clearInterval(this.time)
            this.show = false
          }
        }, 100)
      })
    },
    updateHandle () {
      this.action = 'success'
    },
    cancelHandle () {
      this.action = 'cancel'
    },
    checkData (data) {
      return typeof data === 'number' && isNaN(data)
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 700px;
  h3 {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EditLayer/EditLayer.vue